<template>
  <div class="tooltip">
    <a-timeline>
      <template v-for="(item, index) in props.timeLine" :key="index">
        <a-timeline-item :color="item.color"
          >
          <p>{{ item.content }}</p>
          <p v-if="item.time">{{ item.time }}</p>
          </a-timeline-item
        >
      </template>
    </a-timeline>
  </div>
</template>

<script>
import { defineComponent, watch } from "vue";

export default defineComponent({
  props: {
    timeLine: Object,
  },
  setup(props) {
    return {
      props,
    };
  },
});
</script>

<style lang="less" scoped>
.tooltip {
    padding: 20px 20px 0px;
}

:deep(.ant-timeline-item-last > .ant-timeline-item-content) {
    min-height: unset;
}
</style>
